import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNACard, DNAText, DNATextProps, useTheme } from '@alucio/lux-ui';
import { DocumentAccessLevel } from '@alucio/aws-beacon-amplify/src/models';
import { DNACustomFieldChipList, DNADocumentThumbnail, RenderExcerpt } from 'src/components/DNA';
import { DocumentORM } from 'src/types/types';
import { DNARowsComponent } from 'src/components/DNA/FlatList/Rows/types';
import { CustomLabelDisplay } from '../default/CustomLabelDisplay';
import { useDocumentSearchV2Context } from 'src/hooks/useDocumentSearchV2';

const styles = StyleSheet.create({
  cardStyle: {
    backgroundColor: 'transparent',
  },
  titleText: {
    marginLeft: 24,
    paddingRight: 16,
  },
});

const DNACustomDeckDocumentRow: DNARowsComponent<
  DocumentORM
> = (props) => {
  const {
    ORM: documentORM,
    onPress,
    style,
    isOnline,
    isSearch,
  } = props

  const theme = useTheme()
  const isPersonalFile = documentORM.model.accessLevel === DocumentAccessLevel.USER;

  const unavailableContent = (
    !isOnline &&
    !documentORM.relations.version
      .latestPublishedDocumentVersionORM
      ?.meta.assets.isContentCached
  )

  const processed = documentORM
    .relations.version.latestPublishedDocumentVersionORM?.model.conversionStatus === 'PROCESSED';

  const { documentIdSnippetMap } = useDocumentSearchV2Context();
  const snippet = documentIdSnippetMap.get(documentORM.model.id);

  const titleProps: DNATextProps = {
    b1: true,
    testID: 'document-gridlist-name',
    numberOfLines: 3,
  }

  const snippetProps: DNATextProps = {
    status: 'subtle',
    numberOfLines: 3,
    testID: 'drop-down-results-snippet',
  }

  const showSnippet = snippet?.documentExcerpt && isSearch;
  return (
    <DNACard
      appearance="flat"
      interactive="pressable"
      onPress={() => {
        processed && onPress?.(documentORM) }
      }
      style={[
        {
          paddingHorizontal: theme['row-padding-horizontal'],
          paddingVertical: theme['row-padding-vertical'],
        },
        style,
        styles.cardStyle,
      ]}
    >
      <DNABox fill alignY="center">
        <DNABox fill alignY="center">
          <DNABox>
            <DNADocumentThumbnail.Hover
              unavailableContent={unavailableContent}
              documentVersionORM={
                documentORM.relations.version.latestPublishedDocumentVersionORM ||
                documentORM.relations.version.latestDocumentVersionORM
              }
              width={isSearch ? 160 : 120}
              height={isSearch ? 90 : 68}
              showProcessing
            />
          </DNABox>
          {/* Title */}
          <DNABox fill appearance="col" spacing="sm" style={styles.titleText}>
            {snippet?.title
              ? <RenderExcerpt
                  textProps={titleProps}
                  text={snippet.title.text}
              />
              : <DNAText {...titleProps} >
                {documentORM.relations.version.latestUsableDocumentVersionORM.model.title}</DNAText>}
            {showSnippet &&
             (<RenderExcerpt
               pageNumber={snippet.pageNumber}
               textProps={snippetProps}
               text={snippet.documentExcerpt.text}
             />
             )
            }
            {
              !isPersonalFile &&
                <DNABox alignY="center" spacing="sm" fill childFill={1}>
                  <DNACustomFieldChipList
                    documentVersionORM={documentORM.relations.version.latestPublishedDocumentVersionORM}
                  />
                  <CustomLabelDisplay documentORM={documentORM} />
                </DNABox>
            }
          </DNABox>
        </DNABox>
      </DNABox>
    </DNACard>
  )
}

export default DNACustomDeckDocumentRow
